import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import { ChangeOfAuditor, ChangeOfAuditorForm } from "./auditorDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<ChangeOfAuditor>,
  data?: ChangeOfAuditor,
): ChangeOfAuditorForm {
  return new ChangeOfAuditorForm(dispatch, context, data);
}

export function handleEvent(form: ChangeOfAuditorForm, event: DbotEvent) {
  form.handleEvent(event);
}

export function applyForm(form: ChangeOfAuditorForm): ChangeOfAuditor {
  return {
    type: DecisionType.auditor,
    name: form.selectedCompanyForAuditor?.name,
    email: form.emailModel.validatedValue,
    organisationNumber: form.selectedCompanyForAuditor?.organizationnumber,
    businessAddress1: form.selectedCompanyForAuditor?.address,
    businessAddress2: form.selectedCompanyForAuditor?.address2,
    businessCity: form.selectedCompanyForAuditor?.city,
    businessCountry: form.selectedCompanyForAuditor?.sourceCountry,
    businessZip: form.selectedCompanyForAuditor?.zip,
  };
}

export function validate(form: ChangeOfAuditorForm): boolean {
  return form.validate();
}

export function isValid(form: ChangeOfAuditorForm): boolean {
  return form.isValid;
}

export const auditorHandler: DecisionTypeHandler<
  DecisionType.auditor,
  ChangeOfAuditor,
  ChangeOfAuditorForm
> = {
  type: DecisionType.auditor,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
